<template>
    <div class="Visitor_AFRAME">    
        <div class="Visitor_AFRAME__header">AFRAME</div>

        <a-scene>
            <a-entity foo></a-entity>
        </a-scene>


    </div>
</template>

<script>

export default {

    name: 'Visitor_AFRAME',
    beforeCreate() {
        AFRAME.registerComponent('foo', {
            schema: {
                ready: { type: 'string', default: 'Callback completed!' },
            },
            callback: (b)=> {
                this.onReady(b)
            },
            init:  function() {
                console.log('FOO!');
                this.callback(this.data.ready)
            }
        })
    },

    mounted() {
        this.$nextTick(()=>{
            var fooComponent = document.querySelector('[foo]').components.foo;
            console.log('x');
        })
    },

    methods: {
        onReady(b) {
            console.log(b);
        },  
    }

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Visitor_AFRAME
    overflow hidden
    position absolute
    width 100vw
    height 100%
    color black
    background white

    &__header 
        // opacity 
        // border 4px solid purple 
        width 90px
        height 30px
        top 8px
        left 8px
        position fixed
        z-index 10000

</style>